import { render, staticRenderFns } from "./HelpButton.vue?vue&type=template&id=12d2c490&"
import script from "./HelpButton.vue?vue&type=script&lang=js&"
export * from "./HelpButton.vue?vue&type=script&lang=js&"
import style0 from "./HelpButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports